module.exports = __webpack_public_path__ + "img/Triangle 1.249ec37f.svg";